module.exports = __webpack_public_path__ + "img/phone-ic.ae9997c3.svg";